import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface SchedulerSettings {
  earliestTime: string;
  latestTime: string;
  minimumGap: number;
  preferredTimes: string[];
  blackoutPeriods: Array<{
    start: string;
    end: string;
    days?: number[];
  }>;
}

interface SchedulerState {
  settings: SchedulerSettings;
  updateSettings: (settings: Partial<SchedulerSettings>) => void;
  resetSettings: () => void;
}

const defaultSettings: SchedulerSettings = {
  earliestTime: '06:00',
  latestTime: '20:00',
  minimumGap: 45,
  preferredTimes: ['07:00', '12:00', '17:00'],
  blackoutPeriods: [
    {
      start: '13:00',
      end: '14:00',
      days: [1, 2, 3, 4, 5] // Weekdays only
    }
  ]
};

export const useSchedulerStore = create<SchedulerState>()(
  persist(
    (set) => ({
      settings: defaultSettings,
      updateSettings: (newSettings) =>
        set((state) => ({
          settings: { ...state.settings, ...newSettings }
        })),
      resetSettings: () => set({ settings: defaultSettings })
    }),
    {
      name: 'scheduler-settings',
      version: 1
    }
  )
);